<template>
    <li class="pull-right">
        <a href="#" @click="toggleSearch" class="btn submit"><i class="icon-magnifier"></i></a>
    </li>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'MenuSearch',

        computed: {
            ...mapState([
                'full_screen_search_open'
            ])
        },

        methods: {
            toggleSearch() {
                //remove params from url if closing
                if(this.full_screen_search_open) {
                    let params = new URLSearchParams(location.search);

                    if(params.has('search')) {
                        params.delete('search');
                    }

                    if(params.has('order_by')) {
                        params.delete('order_by');
                    }

                    window.history.replaceState({}, '', `${location.pathname}?${params}`);
                }

                this.$store.commit('toggleFullScreenSearch');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .hamburger {
        top: auto;
        margin: 0;
    }

    @media(max-width: 992px) {
        li {
            height: auto;

            &:before {
                width: 100% !important;
            }
        }

        .pull-right {
            float: none !important;
        }

        .btn {
            text-align: left !important;
        }
    }
</style>